<template>
  <b-card data-test-id="GridHelpContentComponent" no-body class="mb-1">
    <b-card-header header-tag="header" class="p-1" role="tab">
      <b-button v-b-toggle.accordion-1 block href="#" variant="outline-primary">Using the Grid</b-button>
    </b-card-header>
    <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
      <b-card-body>
        <div style="width: 100%;">
          <b-card-text
            >The <b>data grid</b> includes several features to make working with your data easier.</b-card-text
          >
          <b-card-text
            >Clicking on a column heading will <b>sort</b> the rows based on the selected column.</b-card-text
          >
          <img src="../assets/GridSort.png" width="400" class="center" />
          <br />
          <b-card-text
            >Clicking to the hamburger icon in the column header will let you <b>filter</b> the rows on the selected
            column.</b-card-text
          >
          <img src="../assets/GridFilter.png" width="400" class="center" />
          <br />
          <b-card-text>Columns can also be <b>resized</b> by dragging the column separator in the header.</b-card-text>
          <img src="../assets/GridResize.png" width="400" class="center" />
          <br />
          <b-card-text>Clicking a row will <b>select</b> it. Clicking it again will <b>de-select</b> it.</b-card-text>
        </div>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  name: "GridHelpContent"
};
</script>

<style scoped lang="css">
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
</style>
